import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { SecurityService } from '../../../services/security/security.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal from "sweetalert2";

@Component({
  selector: 'app-listado-rol',
  templateUrl: './listado-rol.component.html',
  styleUrls: ['./listado-rol.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class ListadoRolComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  abrirPopUpRol: boolean = false;
  user: any;
  ipAddress: any;
  repRoles: any = [];
  loading: boolean = false;
  data: any = {};
  id_rol: any = 1;

  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  displayedColumns: string[] =
    ['Checked', 'Sistema', 'Nombre', 'Estado'];

  dataSource = new MatTableDataSource(this.repRoles);

  constructor(private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private router: Router) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.id_rol = this.user.id_roles;
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.data.NombreProyecto = 'DigitalFactoring';
    this.data.Usuario = this.user.Usuario;
    this.data.Host = 'INTRANET';
    this.data.IP = this.ipAddress.ip;
    this.data.Canal = 'W';
  }

  ngOnInit() {
    this.ObtenerListaRoles();
  }

  ObtenerListaRoles() {
    this.loading = true;
    this.securityService.ObtenerListaRoles(this.user.id_empresa)
      .subscribe(resp => {
        this.repRoles = resp
        this.dataSource = new MatTableDataSource(this.repRoles);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ROLES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  EliminarRol(element: any) {

    this.data.id_roles = element.id_roles;
    this.data.Estado = '0';

    Swal.fire({
      title: '',
      text: '¿Estás seguro de eliminar el id: ' + element.id_roles + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Espere',
          text: 'Eliminando Información',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();
        this.securityService.EliminarRol(this.data)
          .subscribe(res => {
            Swal.fire({
              title: '¡El rol se ha eliminado!',
              text: res["message"],
              type: 'success',
              heightAuto: false
            }).then(resp => {
              if (resp.value) {
                this.ngOnInit();
              }
            });
          }, (err: HttpErrorResponse) => {
            if (err.error instanceof ErrorEvent) {
              console.error(err);
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "NO SE ELIMINÓ ROL. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            })
          })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.loading = false;
      }
    })
  }


  agregarRol() {
    this.securityService.dataRol = '';
    this.abrirPopUpRol = true;
  }

  EditarRol(elemento: any) {
    this.securityService.dataRol = elemento;
    this.abrirPopUpRol = true;

  }
  CerrarPopUpRol() {
    this.abrirPopUpRol = false;
  }

  Refresh() {
    this.ngOnInit();
  }



}
